import { Grid, Typography } from "@mui/material";
import {
  LoadingButton,
  UploadButton,
} from "../../../../components/button/Button";
import { ENV_LISTS } from "../../../../core/EnvTranspiler";
import { useDownloadBlobAsFile } from "../../../../hooks/useDownloadBlobAsFile";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useImportCategory } from "../../../produk/api/product/category/resolver";

export const useTableProperties = () => {
  const renderRight = () => {
    const { mutate: mutateUpload, isLoading: isLoadingUpload } =
      useImportCategory();
    const { download, isLoading: isLoadingDownload } = useDownloadBlobAsFile();
    const urlDownload = `${ENV_LISTS.API_URL}/product/category/export`;

    return (
      <Grid container spacing={2} maxWidth={250}>
        <Grid item xs={12} mt={2}>
          <LoadingButton
            style={{ width: "100%" }}
            onClick={() => download(urlDownload, "Category_Export")}
            isLoading={isLoadingDownload}
            text="Export"
            icon={<CloudDownloadIcon />}
          />
          <Typography variant="caption" mt={1}>
            Export data kategori menjadi <strong>.csv</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <UploadButton
            style={{ width: "100%" }}
            text="Upload"
            onChange={(e) => {
              if (e) {
                mutateUpload({ file: e[0] });
              }
            }}
            isLoading={isLoadingUpload}
          />
          <Typography variant="caption" mt={1}>
            Import data kategori dengan file <strong>.csv</strong>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  return {
    renderRight,
  };
};

export default useTableProperties;
